import { jsx as l } from "react/jsx-runtime";
const e = (a) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentcolor",
        d: "M14.53 2.224a2.5 2.5 0 0 0-2.124-.398 2.5 2.5 0 0 0-1.518 1.164L8.332 7.417a2.87 2.87 0 0 0-2.717-1.822 2.5 2.5 0 0 0-2.459 2.472c-.042 3.807-.05 6.053-.017 6.667l.02.363v.001a7 7 0 0 0 3.203 5.478q.05.037.106.07l1.732 1a7 7 0 0 0 9.562-2.562l4.25-7.361a2.5 2.5 0 0 0-.706-3.28l-2.873 4.977a.5.5 0 0 1-.866-.5l3.176-5.5A2.5 2.5 0 0 0 19.1 4.89l-3.565 6.175a.5.5 0 1 1-.866-.5l4.25-7.362a.5.5 0 0 1 .066-.09 2.5 2.5 0 0 0-2.937-1.53 1 1 0 0 1-.035.073l-4.25 7.361a.5.5 0 1 1-.866-.5z"
      }
    )
  }
);
export {
  e as default
};
